module.exports = __webpack_public_path__ + "static/media/revenue-operations-main.1e15c845.svg";